import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { clearToken, logout } from "./authSlice";

const companySlice = createSlice({
  name: "company",
  initialState: { currentCompanyId: null as number | null },
  reducers: {
    setCompanyId: (state, action: PayloadAction<number | null>) => {
      state.currentCompanyId = action.payload;
    },
    clearCompanyId: (state) => {
      state.currentCompanyId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, (state) => {
        state.currentCompanyId = null;
      })
      .addCase(clearToken, (state) => {
        state.currentCompanyId = null;
      });
  },
});

export const { setCompanyId, clearCompanyId } = companySlice.actions;
export default companySlice.reducer;
